import React, { useState } from 'react'
 
 
import TrainingDetailsList from './TrainingDetailsList';
import TrainingDetailsForm from './TrainingDetailsForm';

const TrainingDetails= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <TrainingDetailsForm addForm={setFromIsShown} update={upData} />
        ) : (
          <TrainingDetailsList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default TrainingDetails